import { Center, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';

import classes from './NoContent.module.css';

interface NoContentPlaceholderProps {
  title: string | null;
  description?: string | null;
  actions?: ReactNode;
  mih?: string;
}

export function NoContentPlaceholder({ title, description, actions, mih }: NoContentPlaceholderProps) {
  return (
    <Center
      dir="column"
      className={classes.placeholderContainer}
      mih={mih}
    >
      <Stack
        gap="xs"
        align="center"
      >
        <Text
          fw="600"
          size="lg"
        >
          {title}
        </Text>
        <Text c="dimmed">{description}</Text>
        {actions}
      </Stack>
    </Center>
  );
}
